import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Menu, MenuItem, MenuModule } from '../model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(private http: HttpClient, private translateService: TranslateService) {}

  load(): Observable<Menu> {
    return this.http.get<Menu>(`${environment.api.nilo.user.view}/users/view/menu`);
  }

  mapAndTranslateMenuModules = (source: Observable<Menu>): Observable<MenuModule[]> =>
    source.pipe(
      switchMap((menu) =>
        //Load menu translations in advance.
        this.translateService.get('menu.').pipe(
          map(() =>
            menu.items.map(
              (module): MenuModule => ({
                name: this.translateService.instant(`menu.${module.name}`),
                items: this.itemsSortReducer(module.items),
              }),
            ),
          ),
        ),
      ),
    );

  /**
   * Reduces the nested items to a flat list and adds translation
   * @param items
   */
  private itemsSortReducer = (items: MenuItem[]): MenuItem[] =>
    items
      .map(({ name, ...item }) => ({
        ...item,
        name: this.translateService.instant(`menu.${name}`),
      }))
      .sort(this.byChildrenAndName)
      .reduce(this.toFlatTranslatedItemsArray, []);

  private byChildrenAndName = (a, b) => {
    if (!!a.items.length === !!b.items.length) return a.name.localeCompare(b.name);
    if (a.items.length) return 1;
    return -1;
  };

  private toFlatTranslatedItemsArray = (acc, { items, ...item }: MenuItem): MenuItem[] => [
    ...acc,
    item,
    ...items
      .map(({ items: innerItems, ...innerItem }) => ({
        ...innerItem,
        name: this.translateService.instant(`menu.${innerItem.name}`),
      }))
      .sort((a, b) => a.name.localeCompare(b.name)),
  ];
}
